import type { OrderSnapshot } from './orderSpecs';
import { a204words } from '../ui/a204words';
import { btn, h } from '../ui/icons';
import { modalFocus } from '../ui/modalFocus';

export const DOSSIER_CONSENT_VERSION = 'a204-order-v1';
export function orderConsent(host: HTMLElement, label: string, days: number): { promise: Promise<boolean>; cancel: () => void } {
  const w = a204words(), root = h('div', 'mt-font-overlay mt-order-consent');
  const sheet = h('section', 'mt-font-drawer');
  sheet.setAttribute('aria-label', w.consent);
  const checkbox = h('input'); checkbox.type = 'checkbox';
  const accept = h('label', 'mt-order-accept'); accept.append(checkbox, document.createTextNode(w.consentBody));
  const yes = btn('mt-cta', w.confirm); yes.disabled = true;
  checkbox.onchange = () => { yes.disabled = !checkbox.checked; };
  const no = btn('mt-cta-secondary', w.cancel);
  sheet.append(h('h2', 'mt-eng-card-title', w.consent), h('p', '', label), accept, h('p', 'mt-eng-note', w.retention(days)), yes, no);
  root.append(sheet); host.append(root);
  let finish!: (ok: boolean) => void;
  const promise = new Promise<boolean>(resolve => { finish = resolve; });
  const release = modalFocus(sheet, () => close(false));
  const close = (ok: boolean) => { release(); root.remove(); finish(ok); };
  root.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(false); } });
  yes.onclick = () => { if (checkbox.checked) close(true); }; no.onclick = () => close(false);
  return { promise, cancel: () => close(false) };
}

/** Called only after explicit order consent; no upload happens during try-on or export. */
export async function uploadDossier(url: string, id: string, photo: File, pdf: File, snapshot: OrderSnapshot, code: string, signal: AbortSignal): Promise<string> {
  const endpoint = new URL(url);
  if (endpoint.protocol !== 'https:' && endpoint.hostname !== 'localhost' && endpoint.hostname !== '127.0.0.1') throw new Error('Invalid private endpoint');
  const body = new FormData();
  body.set('id', id); body.set('photo', photo); body.set('pdf', pdf);
  body.set('snapshot', JSON.stringify(snapshot)); body.set('code', code);
  body.set('consent', DOSSIER_CONSENT_VERSION);
  const response = await fetch(endpoint, { method: 'POST', headers: { 'X-Mata-Dossier': id }, body, signal, credentials: 'omit', redirect: 'error' });
  if (!response.ok) throw new Error(`Dossier upload ${response.status}`);
  const result = await response.json() as { id?: unknown; complete?: unknown };
  if (result.id !== id || result.complete !== true) throw new Error('Incomplete dossier');
  return id;
}
